const customDashboardControllers = angular.module('custom-dashboard.module', [
  'ui.router',
]);

customDashboardControllers.controller('customDashboardController', function(
  $scope,
  $uibModal,
  $rootScope,
  gridletService,
  userViewService,
  eventService
) {
  $scope.view = 'dashboard2';
  userViewService.setView('dashboard2');

  $scope.customizable = angular.copy(gridletService.getCustomizable());

  let unbindCustomDash = $rootScope.$on('toggle-customization', function(
    event,
    args
  ) {
    $scope.customizable = args.customize;
  });
  $scope.$on('$destroy', unbindCustomDash);

  eventService.on('reset-widgets', function() {
    $scope.$broadcast('update-gridlet-list');
  });

  eventService.on('restore-default-widgets', function() {
    $scope.$broadcast('restore-default-widgets');
  });

  let unbindCustomAddGridlet = $rootScope.$on('add-gridlet', function(
    event,
    args
  ) {
    if (args.currentTab !== 'dashboard2') return;
    gridletService.addNewGridlet($scope.view, args.gridletId);
    $scope.$broadcast('update-gridlet-list');
  });
  $scope.$on('$destroy', unbindCustomAddGridlet);

  $scope.$on('$destroy', function() {
    if ($scope.customizable) {
      $scope.customizable = false;
      $rootScope.$emit('disable-customization');
    }
  });
});
